/**
 * XẾP HẠNG KẾT QUẢ Ô "GÕ ĐỂ NHẢY" — quyết định THUẦN, không chạm React.
 *
 * ⚠ Tách khỏi `Layout.tsx` có lý do đo được: bộ kiểm chạy trong `server/`, và nhập thẳng
 *   `Layout.tsx` thì nó kéo theo `react` rồi vỡ. Nhưng cái vỡ ấy chỉ ra một điều đúng hơn —
 *   **luật xếp hạng là một quyết định thuần, nó không thuộc về một thành phần giao diện.**
 *   Tách ra rồi thì kiểm được bằng hàm, và chỗ khác dùng lại được.
 */

/** Đúng ba trường đem đi so. Thành phần giao diện tự dựng chúng rồi gọi vào đây. */
export interface KhopDuoc {
  /** MÃ ĐỊNH DANH — mã tủ, `hardwareId`, mã đường. Khớp tiền tố ở đây thắng mọi khớp khác. */
  ma: string;
  /** Tên đọc được. Khớp tiền tố ở đây đứng hạng hai. */
  ten: string;
  /** Mọi thứ còn lại: địa chỉ, nhãn cảnh báo đang mở, mã thiết bị. */
  them: string;
}

/**
 * ─────────────────────────────────────────────────────────────────────────────────────
 * 🔴 XẾP HẠNG — dựng luật rồi lee chỉnh trọng số, KHÔNG chờ lee phát minh hình dạng.
 *
 * Bản đầu xếp theo thứ tự cây và tôi định *"chờ xem lee gõ kiểu gì"*. Đó lại là **L20**:
 * câu ấy giả định **chỉ có một kiểu gõ**. Có ba, và chúng phân biệt được bằng chính chuỗi gõ:
 *
 * | Gõ | Ý | Phải lên đầu |
 * |---|---|---|
 * | `TU-0417`, một `hardwareId` | *"đúng cái này"* | khớp TIỀN TỐ mã, tuyệt đối |
 * | `nguyễn` | *"cái đường ấy"* | khớp tên đường, rồi tủ thuộc đường đó |
 * | `mất công tơ` | *"cái nào đang hỏng"* | khớp nhãn cảnh báo, mức Nguy trước |
 *
 * ⚠ Ba hạng, và **thứ tự cây chỉ là tiêu chí CUỐI CÙNG** — nó phá hoà, không xếp hạng.
 * ─────────────────────────────────────────────────────────────────────────────────────
 */
const HANG = { maTienTo: 0, tenTienTo: 1, maGiua: 2, tenGiua: 3, themGiua: 4, khong: 9 } as const;

export function hangKhop(m: KhopDuoc, tu: string): number {
  const k = tu.trim().toLowerCase();
  if (!k) return HANG.khong;
  if (m.ma.startsWith(k)) return HANG.maTienTo;
  if (m.ten.startsWith(k)) return HANG.tenTienTo;
  if (m.ma.includes(k)) return HANG.maGiua;
  if (m.ten.includes(k)) return HANG.tenGiua;
  if (m.them.includes(k)) return HANG.themGiua;
  return HANG.khong;
}

/**
 * So hai mục. Thứ tự quyết định, đúng ba nấc:
 *   1. hạng khớp *(tiền tố thắng khớp giữa chuỗi)*
 *   2. đang có cảnh báo mức NGUY
 *   3. thứ tự cây — **chỉ để phá hoà**
 */
export function soSanhNhay(
  a: { hang: number; dangNguy: boolean; thuTu: number },
  b: { hang: number; dangNguy: boolean; thuTu: number },
): number {
  if (a.hang !== b.hang) return a.hang - b.hang;
  if (a.dangNguy !== b.dangNguy) return a.dangNguy ? -1 : 1;
  return a.thuTu - b.thuTu;
}
